/* eslint-disable no-useless-constructor */
/* eslint-disable class-methods-use-this */
/* eslint-disable func-names */
/* eslint-disable no-use-before-define */
/* eslint-disable no-var */
function getFocusableElements(container) {
  return Array.from(
    container.querySelectorAll(
      "summary, a[href], button:enabled, [tabindex]:not([tabindex^='-']), [draggable], area, input:not([type=hidden]):enabled, select:enabled, textarea:enabled, object, iframe"
    )
  );
}

const trapFocusHandlers = {};

function trapFocus(container, elementToFocus = container) {
  var elements = getFocusableElements(container);
  var first = elements[0];
  var last = elements[elements.length - 1];

  removeTrapFocus();

  trapFocusHandlers.focusin = (e) => {
    if (e.target !== container && e.target !== last && e.target !== first)
      return;

    document.addEventListener("keydown", trapFocusHandlers.keydown);
  };

  trapFocusHandlers.focusout = function () {
    document.removeEventListener("keydown", trapFocusHandlers.keydown);
  };

  trapFocusHandlers.keydown = function (e) {
    if (e.code.toUpperCase() !== "TAB") return; // If not TAB key
    // On the last focusable element and tab forward, focus the first element.
    if (e.target === last && !e.shiftKey) {
      e.preventDefault();
      first.focus();
    }

    //  On the first focusable element and tab backward, focus the last element.
    if ((e.target === container || e.target === first) && e.shiftKey) {
      e.preventDefault();
      last.focus();
    }
  };

  document.addEventListener("focusout", trapFocusHandlers.focusout);
  document.addEventListener("focusin", trapFocusHandlers.focusin);

  elementToFocus.focus();
}

// Here run the querySelector to figure out if the browser supports :focus-visible or not and run code based on it.
try {
  document.querySelector(":focus-visible");
} catch {
  focusVisiblePolyfill();
}

function focusVisiblePolyfill() {
  const navKeys = [
    "ARROWUP",
    "ARROWDOWN",
    "ARROWLEFT",
    "ARROWRIGHT",
    "TAB",
    "ENTER",
    "SPACE",
    "ESCAPE",
    "HOME",
    "END",
    "PAGEUP",
    "PAGEDOWN",
  ];
  let currentFocusedElement = null;
  let mouseClick = null;

  window.addEventListener("keydown", (e) => {
    if (navKeys.includes(e.code.toUpperCase())) {
      mouseClick = false;
    }
  });

  window.addEventListener("mousedown", (e) => {
    mouseClick = true;
  });

  window.addEventListener(
    "focus",
    () => {
      if (currentFocusedElement)
        currentFocusedElement.classList.remove("focused");

      if (mouseClick) return;

      currentFocusedElement = document.activeElement;
      currentFocusedElement.classList.add("focused");
    },
    true
  );
}

function pauseAllMedia() {
  document.querySelectorAll(".js-youtube").forEach((video) => {
    video.contentWindow.postMessage(
      '{"event":"command","func":"' + "pauseVideo" + '","args":""}',
      "*"
    );
  });
  document.querySelectorAll(".js-vimeo").forEach((video) => {
    video.contentWindow.postMessage('{"method":"pause"}', "*");
  });
  document.querySelectorAll("video").forEach((video) => video.pause());
  document.querySelectorAll("product-model").forEach((model) => {
    if (model.modelViewerUI) model.modelViewerUI.pause();
  });
}

function removeTrapFocus(elementToFocus = null) {
  document.removeEventListener("focusin", trapFocusHandlers.focusin);
  document.removeEventListener("focusout", trapFocusHandlers.focusout);
  document.removeEventListener("keydown", trapFocusHandlers.keydown);

  if (elementToFocus) elementToFocus.focus();
}

function onKeyUpEscape(e) {
  if (e.code.toUpperCase() !== "ESCAPE") return;

  const openDetailsElement = e.target.closest("details[open]");
  if (!openDetailsElement) return;

  const summaryElement = openDetailsElement.querySelector("summary");
  openDetailsElement.removeAttribute("open");
  summaryElement.focus();
}

function debounce(fn, wait) {
  let t;
  return (...args) => {
    clearTimeout(t);
    t = setTimeout(() => fn.apply(this, args), wait);
  };
}

function fetchConfig(type = "json") {
  return {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      Accept: `application/${type}`,
    },
  };
}

/*
 ******* Mage Added Code Here *******
 */

//  Variant Code
const cache = {};

function getProductJson(
  slug = window.location.pathname.split("/").reverse()[0],
  opts = {}
) {
  if (cache[slug] && !opts.refetch) return Promise.resolve(cache[slug]);

  return fetch(`${window.location.origin}/products/${slug}.json`)
    .then((res) => res.json())
    .then(({ product }) => {
      cache[slug] = product;
      return product;
    });
}

function radio(radios, cb) {
  radios.map((r) => (r.onclick = (e) => cb(e.target.value, e.target.title)));
}

function productSelection(node, opts) {
  opts = Object.assign(
    {
      select: "[data-option-select]",
      radio: "[data-option-radio]",
      main: "[data-option-main]",
      price: "[data-selected-var-price]",
      compareAtPrice: "[data-selected-var-compare]",
      priceGet: "[data-variant-price]",
      prodForm: "[data-prod-form]",
      atc: "[data-atc]",
      atcCopy: "[data-atc-copy]",
      bis: "[data-bis]",
      prelaunch: "[data-prelaunch]",
      payBtn: "[data-pay-btn]",
      shopPay: "[data-shop-pay]",
      prodImgs: "[data-prod-img]",
      slider: "[data-component-slider]",
    },
    opts
  );

  const listeners = [];

  const state = {
    id: null,
    currentColor: null,
    options: [],
  };

  const selects = document.querySelectorAll(opts.select);
  const radios = document.querySelectorAll(opts.radio);
  const main = document.querySelector(opts.main);
  const price = document.querySelectorAll(opts.price);
  const compareAtPrice = document.querySelectorAll(opts.compareAtPrice);
  const prodForm = document.querySelector(opts.prodForm);
  const atc = document.querySelector(opts.atc);
  const atcCopy = document.querySelectorAll(opts.atcCopy);
  const bis = document.querySelector(opts.bis);
  const prelaunch = document.querySelector(opts.prelaunch);
  const payBtn = document.querySelector(opts.payBtn);
  const shopPay = document.querySelector(opts.shopPay);
  const prodImgs = document.querySelectorAll(opts.prodImgs);
  const slider = document.querySelector(opts.slider);

  if (!main || !main.length) throw Error("data-option-main is missing");
  if (radios.length > 3) throw Error("you have more than three radio groups");
  if (selects.length > 3) throw Error("you have more than three select inputs");

  const variants = [].slice.call(main.children).reduce((variants, child) => {
    // the below line spits the variant ID's
    variants[child.innerHTML] = child.value;
    return variants;
  }, {});

  // Make JSON available to consume tags object
  const json = JSON.parse(document.querySelector(".js-product-json").innerHTML);
  const { product } = json;

  console.log("product tags:", product.tags);

  const tags = product.tags.join("~").toLowerCase();
  const lowercaseTags = tags.split("~");

  const preorder = lowercaseTags.includes("preorder");
  const discontinued = lowercaseTags.includes("discontinued");
  const comingSoon = lowercaseTags.includes("coming-soon");

  let oosDiscontinuedCopy = "";

  if (discontinued) {
    oosDiscontinuedCopy = "Discontinued";
  } else {
    oosDiscontinuedCopy = "Out of Stock";
  }
  // // TODO: Return to this to properly enable 'Coming Soon' ATC option. -ae 04.22.22
  // const oosDiscontinuedCopy = {
  //   discontinued:'Discontinued',
  //   comingSoon:'Coming Soon'
  // }

  let atcPreorderCopy = "";

  if (preorder) {
    atcPreorderCopy = "Preorder";
  } else {
    atcPreorderCopy = "Add to Cart";
  }

  selects.forEach((select) => {
    if (select.nodeName !== "SELECT")
      throw new Error(
        "data-option-select should be defined on the individual option selectors"
      );

    const index = parseInt(select.getAttribute("data-index"), 10);

    // set initial value
    state.options[index] = select.value;

    select.addEventListener("change", (e) => {
      state.options[index] = e.target.value;
      updateSelection();
    });
  });

  radios.forEach((r) => {
    if (r.nodeName === "INPUT")
      throw Error(
        "data-option-radio should be defined on a parent of the radio group, not the inputs themselves"
      );
    // data index defines radio group
    const index = parseInt(r.getAttribute("data-index"), 10);
    const inputs = [].slice.call(r.getElementsByTagName("input"));
    const labelCurrent = r.querySelectorAll("[data-option-current]");
    const labelCurrentTitle =
      labelCurrent[0].dataset.optionCurrent.toLowerCase();
    // set initial value
    inputs.forEach((a) => {
      if (a.checked) state.options[index] = a.dataset.valueHandle;
      if (
        (a.name.toLowerCase() == "color" ||
         a.name.toLowerCase() == "finish" ||
         a.name.toLowerCase() == "handle" ||
         a.name.toLowerCase() == "material" ||
         a.name.toLowerCase() == "handle-material" ) && a.checked
      )
        state.currentColor = a.value;
      // console.log(`what is labelCurrent ${labelCurrent}`);
      // console.log(`current state is – ${state.options[index]}`);
      // console.table(state);
    });

    radio(inputs, (value, label) => {
      state.options[index] = value;

      if (labelCurrentTitle == "color" ||
          labelCurrentTitle == "finish" ||
          labelCurrentTitle == "handle" ||
          labelCurrentTitle == "material" ||
          labelCurrentTitle == "handle-material") {
        state.currentColor = value;
      }

      console.log("state.currentColor", state.currentColor);

      labelCurrent.forEach((l) => {
        l.innerHTML = label;
      });
      // labelCurrent.innerHTML = label;
      updateSelection();
    });
  });

  getInitial();

  function getInitial() {
    console.log("state.options", state.options);
    state.id = variants[state.options.join("-")];
    console.log("Initial state.id", state.id);
    state.string = state.options.join("-");
    console.log("Initial state.string", state.string);
    state.uniqString = "[" + state.string + "]";
    console.log("Initial state.uniqString", state.uniqString);
    state.altStringsPresent = false;
    state.altUniqMatchPresent = false;
    main.value = state.id;
    const mainOpt = main.options[main.selectedIndex];
    const mainInv = mainOpt.dataset.variantInventoryQuantity;
    const invManagement =
      mainOpt.dataset.variantInventoryManagement.length > 0 || false;
    const currentPrice = mainOpt.getAttribute("data-variant-price");
    const currentCompareAtPrice = mainOpt.getAttribute("data-variant-compare");
    const priceInt = parseFloat(currentPrice.substring(1));
    // Returns true if variant inventory policy set to disallow OOS purchase
    let mainPolicy = mainOpt.dataset.variantInventoryPolicy === "deny" || false;
    // If there's nothing tracking inventory policy, it should be false
    if (invManagement === false) {
      mainPolicy = false;
    }
    // If inventory less than or equal to zero & if inventory policy set to disallow OOS purchases
    if (mainInv <= 0 && mainPolicy) {
      atcCopy.forEach((copy) => {
        copy.innerHTML = oosDiscontinuedCopy;
        atc.setAttribute("disabled", "");
      });
      if (bis !== null && discontinued === false) {
        bis.classList.remove("is-hidden");
        atc.classList.add("is-hidden");
        prodForm.classList.add("is-hidden");
      }
      // Hide 3rd Party Checkout buttons if OOS
      payBtn?.classList.add("is-hidden");
    }
    // If available inventory
    if (mainInv > 0 && mainPolicy) {
      atcCopy.forEach((copy) => {
        copy.innerHTML = atcPreorderCopy;
        if (atc.hasAttribute("disabled")) {
          atc.removeAttribute("disabled");
        }
        // Hide Back In Stock
        if (bis !== null && discontinued === false) {
          bis.classList.add("is-hidden");
          atc.classList.remove("is-hidden");
          prodForm.classList.remove("is-hidden");
        }
        payBtn?.classList.remove("is-hidden");
      });
    }
    // If prelaunch present
    if (prelaunch !== null) {
      prelaunch.classList.remove("is-hidden");
      atc.classList.add("is-hidden");
      prodForm.classList.add("is-hidden");
      if (bis !== null) {
        bis.classList.add("is-hidden");
      }

      // Hide 3rd Party Checkout buttons if Prelaunch
      payBtn?.classList.add("is-hidden");
    }

    // get all images on screen
    // check if any elements have altString
    prodImgs.forEach((el) => {
      if (el.dataset.prodImg.toString().length > 0) {
        state.altStringsPresent = true;
      }
      if (el.dataset.prodImg.toString().includes(state.uniqString)) {
        state.altUniqMatchPresent = true;
      }
    });
    // if altStrings present then hide all elements with no match or no string
    prodImgs.forEach((el) => {
      altString = el.dataset.prodImg.toString();
      if (altString.length > 0) {
        if (state.currentColor === null) {
          el.classList.remove("is-hidden");
        } else if (altString.includes(state.uniqString)) {
          el.classList.remove("is-hidden");
        }
        // Remove hidden state if no altStrings match uniqStrings
        if (state.altStringsPresent && !state.altUniqMatchPresent) {
          console.log("altStringsPresent but no matches");
          el.classList.remove("is-hidden");
        }
      } else {
        console.log(el, "altString empty");
        // Remove hidden state if no altStrings present for product images
        if (!state.altStringsPresent) {
          console.log("no altStringsPresent");
          el.classList.remove("is-hidden");
        }
      }
    });

    if (slider != undefined) {
      slider.initPages();
    }
    // Only show installments message if price is greater than $50
    // if (priceInt > 50) {
    //   shopPay.classList.remove('is-hidden');
    // } else {
    //   shopPay.classList.add('is-hidden');
    // }
    price.forEach((priceEl) => {
      priceEl.innerHTML = currentPrice;
    });

    compareAtPrice.forEach((compareAtPriceEl) => {
      compareAtPriceEl.innerHTML = currentCompareAtPrice;
    });

    for (const fn of listeners) fn(state);
  }

  // this does all the business of changing pdp content on variant update
  function updateSelection() {
    // match variant id with string of 'variant1 / variant2'
    state.id = variants[state.options.join("-")];
    state.string = state.options.join("-");
    // uniqString allows for variant image swap on items with >2 variant options
    state.uniqString = "[" + state.string + "]";
    console.log("uniqString is", state.uniqString);
    console.log("state.string is", state.string);
    console.log("updated state", state);
    // use variant id to update selected value in hidden <option> element (main)
    main.value = state.id;
    // Add currently selected variant to URL
    window.history.replaceState(main.value, "", `?variant=${main.value}`);

    if (main.value.length > 0) {
      const mainOpt = main.options[main.selectedIndex];
      const mainInv = mainOpt.dataset.variantInventoryQuantity;
      const invManagement =
        mainOpt.dataset.variantInventoryManagement.length > 0 || false;
      const currentPrice = mainOpt.getAttribute("data-variant-price");
      const priceInt = parseFloat(currentPrice.substring(1));
      // Returns true if variant inventory policy set to disallow OOS purchase
      let mainPolicy =
        mainOpt.dataset.variantInventoryPolicy === "deny" || false;
      // If there's nothing tracking inventory policy, it should be false
      if (invManagement === false) {
        mainPolicy = false;
      }
      console.log(
        `mainOpt reads ${JSON.stringify(
          mainOpt
        )} | mainInv reads ${mainInv} | mainPolicy returns ${mainPolicy} | invManagement returns ${invManagement} | mainValue reads ${
          main.value
        }`
      );
      // If inventory less than or equal to zero & if inventory policy set to disallow OOS purchases
      if (mainInv <= 0 && mainPolicy) {
        atcCopy.forEach((copy) => {
          copy.innerHTML = oosDiscontinuedCopy;
          atc.setAttribute("disabled", "");
        });
        if (bis !== null && discontinued === false) {
          bis.classList.remove("is-hidden");
          atc.classList.add("is-hidden");
          prodForm.classList.add("is-hidden");
        }
        payBtn?.classList.add("is-hidden");
      } else {
        atcCopy.forEach((copy) => {
          copy.innerHTML = atcPreorderCopy;
          if (atc.hasAttribute("disabled")) {
            atc.removeAttribute("disabled");
          }
          if (bis !== null && discontinued === false) {
            bis.classList.add("is-hidden");
            atc.classList.remove("is-hidden");
            prodForm.classList.remove("is-hidden");
          }
          payBtn?.classList.remove("is-hidden");
        });
      }

      // get all images on screen
      prodImgs.forEach((el) => {
        altString = el.dataset.prodImg.toString();
        if (altString.length > 0) {
          // console.log('altString present: ', altString);
          if (altString.includes(state.uniqString)) {
            el.classList.remove("is-hidden");
            state.altUniqMatchPresent = true;
          } else {
            el.classList.add("is-hidden");
          }
          // Remove hidden state if no altStrings match uniqStrings
          if (state.altStringsPresent && !state.altUniqMatchPresent) {
            el.classList.remove("is-hidden");
          }
        } else {
          // Remove hidden state if no altStrings present for product images
          if (!state.altStringsPresent) {
            el.classList.remove("is-hidden");
          }
        }
      });

      if (slider != undefined) {
        slider.initPages();
      }
      // get data-variant-price attr in selected <select>, overwrite currently listed price
      // price.innerHTML = mainOpt.getAttribute('data-variant-price');
      // use above and update price to slater.qs rather than slater.qsa if there's
      // only going to be one element with price listed
      // Hide Shop Pay if price less than 50
      // if (priceInt > 50) {
      //   shopPay.classList.remove('is-hidden');
      // } else {
      //   shopPay.classList.add('is-hidden');
      // }
      price.forEach((priceEl) => {
        priceEl.innerHTML = currentPrice;
      });

      compareAtPrice.forEach((compareAtPriceEl) => {
        compareAtPriceEl.innerHTML = mainOpt.getAttribute("data-variant-compare");
      });
      // todo: add variant id to info emitted
      // app.emit('productOptions:update', { variantSelected: main.value });
      // todo: write catch to update current detail image to current variant on switch
      for (const fn of listeners) fn(state);
    } else {
      // Do this if variant doesn't exist.
      atcCopy.forEach((copy) => {
        copy.innerHTML = "Unavailable";
        // Make sure OOS button isn't visible
        bis.classList.add("is-hidden");
        // Make sure ATC button is visible for unavailable messaging
        atc.classList.remove("is-hidden");
        atc.setAttribute("disabled", "");
      });
    }
  }

  return {
    get state() {
      return state;
    },
    onUpdate(fn) {
      listeners.indexOf(fn) < 0 && listeners.push(fn);
      return () => listeners.splice(listeners.indexOf(fn), 1);
    },
  };
}

//  Cart Code
function fetchCart() {
  return fetch("/cart.js", {
    method: "GET",
    credentials: "include",
  }).then((res) => res.json());
}

function formatVariant(options) {
  if (!options || options.length === 0) return "";

  return options
    .map(({ name, value }) => {
      // Strips "Limited Edition" in Cart Sidebar Item
      if (name.toLowerCase() === "color" && value.indexOf(":") > -1) {
        return value.split(":")[1];
      }

      // Insures we don't display 'Default Title' on products without color options -ae 05.28.20
      if (value === "Default Title") return "";
      return value;
    })
    .join(" / ");
}

function getSizedImageUrl(src, size) {
  if (size === null) {
    return src;
  }

  if (size === "master") {
    return removeProtocol(src);
  }

  var match = src.match(/\.(jpg|jpeg|gif|png|bmp|bitmap|tiff|tif)(\?v=\d+)?$/i);

  if (match) {
    var prefix = src.split(match[0]);
    var suffix = match[0];

    return removeProtocol(prefix[0] + "_" + size + suffix);
  } else {
    return null;
  }
}

function removeProtocol(path) {
  return path.replace(/http(s)?:/, "");
}

// Currency Helpers //--

function formatMoney(cents, format = "{{amount}}") {
  if (typeof cents === "string") {
    cents = cents.replace(".", "");
  }

  let value = "";
  const placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;

  function formatWithDelimiters(number, precision, thousands, decimal) {
    precision = precision || 2;
    thousands = thousands || ",";
    decimal = decimal || ".";

    if (isNaN(number) || number == null) {
      return 0;
    }

    number = (number / 100.0).toFixed(precision);

    const parts = number.split(".");
    const dollarsAmount = parts[0].replace(
      /(\d)(?=(\d\d\d)+(?!\d))/g,
      "$1" + thousands
    );
    const centsAmount = parts[1] ? decimal + parts[1] : "";

    return dollarsAmount + centsAmount;
  }

  switch (format.match(placeholderRegex)[1]) {
    case "amount":
      value = formatWithDelimiters(cents, 2);
      break;
    case "amount_no_decimals":
      value = formatWithDelimiters(cents, 0);
      break;
    case "amount_with_space_separator":
      value = formatWithDelimiters(cents, 2, " ", ".");
      break;
    case "amount_no_decimals_with_comma_separator":
      value = formatWithDelimiters(cents, 0, ",", ".");
      break;
    case "amount_no_decimals_with_space_separator":
      value = formatWithDelimiters(cents, 0, " ");
      break;
  }

  return format.replace(placeholderRegex, value);
}

function addCommasToNumber(num) {
  return num.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
}

function removeTrailingZeros(formattedPrice) {
  // strip ',' from price
  formattedPrice = formattedPrice.replace(/,/g, "");
  currencySymbol = document.querySelector(
    "meta[property='currency-symbol']"
  )?.content;

  if (!currencySymbol) {
    console.error(
      "Currency Symbol not found in theme.liquid meta-tags, defaulting to $"
    );
    currencySymbol = "$";
  }

  if (formattedPrice.includes(currencySymbol)) {
    console.log("formatted price includes currency symbol", currencySymbol);
    if (parseFloat(formattedPrice.substring(1), 10) % 1 === 0) {
      formattedPrice = `${parseInt(formattedPrice.substring(1), 10)}`;
      return currencySymbol + addCommasToNumber(formattedPrice);
    }
  } else {
    console.log("CURRENCY SYMBOL NOT FOUND IN FORMATTED PRICE");
    // price divisible by 1, so no cents
    if (parseFloat(formattedPrice.substring(0), 10) % 1 === 0) {
      formattedPrice = `${parseInt(formattedPrice.substring(0), 10)}`;
      return currencySymbol + addCommasToNumber(formattedPrice);
    } else {
      // price not divisible by 1, so cents exist
      console.log("Likely cents in price");
      formattedPrice = `${formattedPrice}`;
      return currencySymbol + addCommasToNumber(formattedPrice);
    }
  }
  return formattedPrice;
}

// Cart Specific //--

function fetchCart() {
  return fetch("/cart.js", {
    method: "GET",
    credentials: "include",
  }).then((res) => res.json());
}

function formatVariant(options) {
  if (!options || options.length === 0) return "";

  return options
    .map(({ name, value }) => {
      // Strips "Limited Edition" in Cart Sidebar Item
      if (name.toLowerCase() === "color" && value.indexOf(":") > -1) {
        return value.split(":")[1];
      }

      // Insures we don't display 'Default Title' on products without color options -ae 05.28.20
      if (value === "Default Title") return "";
      return value;
    })
    .join(" / ");
}

// this is a stand-in for cart:update from slater
var cartUpdateEvent = new CustomEvent("cart:updated", {
  detail: {
    updated: true,
  },
});

function addVariant(variant, quantity, properties = null) {
  const variantSelectOpt = document.querySelector(
    `[data-option-main] option[value="${variant.id}"]`
  ).dataset;

  if (variantSelectOpt === null) {
    throw new Error(
      "variantSelectOpt undefined, check to make sure data-option-main select exists."
    );
  }
  const numAvailable =
    variantSelectOpt.variantInventoryPolicy === "deny" &&
    variantSelectOpt.variantInventoryManagement === "shopify"
      ? parseInt(variantSelectOpt.variantInventoryQuantity, 10)
      : null; // null means they can add as many as they want

  return fetchCart().then(({ items }) => {
    const existing = items.filter((item) => item.id === variant.id)[0] || {};
    const numRequested = (existing.quantity || 0) + quantity;
    console.log(
      "Here are existing, numRequested, and numAvailable",
      existing,
      numRequested,
      numAvailable
    );
    if (numAvailable !== null && numRequested > numAvailable) {
      const err = `There are only ${numAvailable} of that product available, requested ${numRequested}.`;
      console.log("error", err);
      throw new Error(err);
    } else {
      document.dispatchEvent(cartUpdateEvent);
      return addItemById(variant.id, quantity, properties);
    }
  });
}

function changeAddon(line, quantity) {
  // app.emit('cart:updating');

  return fetch("/cart/change.js", {
    method: "POST",
    credentials: "include",
    headers: {
      "Content-Type": "application/json",
    },
    body: JSON.stringify({ line, quantity }),
  })
    .then((res) => res.json())
    .then((cart) => {
      // app.hydrate({ cart });
      // app.emit('cart:updated', { cart });
      document.dispatchEvent(cartUpdateEvent);
      console.log("cart:updated", { cart });
      return cart;
    });
}

function updateAddon(id, quantity) {
  return fetchCart().then(({ items }) => {
    for (let i = 0; i < items.length; i++) {
      if (items[i].variant_id === parseInt(id)) {
        return changeAddon(i + 1, quantity); // shopify cart is a 1-based index
      }
    }
    document.dispatchEvent(cartUpdateEvent);
  });
}

function removeAddon(id) {
  return updateAddon(id, 0);
}

/**
 * Warning: this does not check available products first
 */
function addItemById(id, quantity, properties = null) {
  // app.emit('cart:updating');
  // if there are line item properties, include them in the add to cart action
  if (properties) {
    return fetch("/cart/add.js", {
      method: "POST",
      credentials: "include",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({ id, quantity, properties }),
    })
      .then((r) => r.json())
      .then((item) =>
        fetchCart().then((cart) => {
          // app.hydrate({ cart });
          // app.emit('cart:updated');
          // app.emit('cart:toggle', state => ({
          //   cartOpen: true,
          // }));
          console.log("cart:updated");
          // app.emit('updated', { item, cart })
          return { item, cart };
        })
      );
  }
  // if there are no line item properties, add as normal
  return fetch("/cart/add.js", {
    method: "POST",
    credentials: "include",
    headers: {
      "Content-Type": "application/json",
    },
    body: JSON.stringify({ id, quantity }),
  })
    .then((r) => r.json())
    .then((item) =>
      fetchCart().then((cart) => {
        let cartDrawer = document.querySelector("cart-drawer");
        if (cartDrawer != null) {
          cartDrawer.open(cart);
          cartDrawer.setActiveElement(document.activeElement);
          document.dispatchEvent(cartUpdateEvent);
        }
        console.log("cart:updated", { item, cart });
        // app.emit('updated', { item, cart })
        return { item, cart };
      })
    );
}

// Hide Gorgias
function hideChatWidget() {
  let chatWidget = ''
  if (document.querySelector("#gorgias-chat-container")) {
    chatWidget = document.querySelector("#gorgias-chat-container");
  } else if (document.querySelector("#front-chat-iframe")) {
    chatWidget = document.querySelector("#front-chat-iframe");
  }
  if (chatWidget != '') {
    chatWidget.style.display = "none";
  } else {
    console.log("ChatWidget not found");
    return;
  }
}

// Show Gorgias
function showChatWidget() {
  let chatWidget = "";
  if (document.querySelector("#gorgias-chat-container")) {
    chatWidget = document.querySelector("#gorgias-chat-container");
  } else if (document.querySelector("#front-chat-iframe")) {
    chatWidget = document.querySelector("#front-chat-iframe");
  }
  if (chatWidget != "") {
    setTimeout(() => {
      chatWidget.style.display = "block";
    }, 400);
  } else {
    console.log("ChatWidget not found");
    return;
  }
}

// Create URL Selects
(function() {
  /**
   * Initialize URL navigation for any <select> element with the
   * data-url-select attribute.
   */
  function initUrlSelects() {
    // Get current pathname.
    const currentPath = window.location.pathname;
    // Select all <select> elements that have the data-url-select attribute.
    const urlSelects = document.querySelectorAll('[data-url-select]');

    // Attach the change event listener to each select element.
    urlSelects.forEach(select => {
      // Loop through all options and set the one that matches the current path as selected.
      Array.from(select.options).forEach((option, index) => {
        const optionPath = new URL(option.value, window.location.origin).pathname;
        if (optionPath === currentPath) {
          select.selectedIndex = index;
        }
      });

      select.addEventListener('change', function(event) {
        const url = event.target.value;
        if (url) {
          window.location.href = url;
        }
      });
      setTimeout(() => {
        select.classList.add("text-visible");
      }, 50);
    });
  };

  // Wait for the DOM to be fully loaded before running the function.
  document.addEventListener('DOMContentLoaded', initUrlSelects);
})();

/*
 * Shopify Common JS
 *
 */
if (typeof window.Shopify == "undefined") {
  window.Shopify = {};
}

Shopify.bind = function (fn, scope) {
  return function () {
    return fn.apply(scope, arguments);
  };
};

Shopify.setSelectorByValue = function (selector, value) {
  for (var i = 0, count = selector.options.length; i < count; i++) {
    var option = selector.options[i];
    if (value == option.value || value == option.innerHTML) {
      selector.selectedIndex = i;
      return i;
    }
  }
};

Shopify.addListener = function (target, eventName, callback) {
  target.addEventListener
    ? target.addEventListener(eventName, callback, false)
    : target.attachEvent("on" + eventName, callback);
};

Shopify.postLink = function (path, options) {
  options = options || {};
  var method = options["method"] || "post";
  var params = options["parameters"] || {};

  var form = document.createElement("form");
  form.setAttribute("method", method);
  form.setAttribute("action", path);

  for (var key in params) {
    var hiddenField = document.createElement("input");
    hiddenField.setAttribute("type", "hidden");
    hiddenField.setAttribute("name", key);
    hiddenField.setAttribute("value", params[key]);
    form.appendChild(hiddenField);
  }
  document.body.appendChild(form);
  form.submit();
  document.body.removeChild(form);
};

Shopify.CountryProvinceSelector = function (
  country_domid,
  province_domid,
  options
) {
  this.countryEl = document.getElementById(country_domid);
  this.provinceEl = document.getElementById(province_domid);
  this.provinceContainer = document.getElementById(
    options["hideElement"] || province_domid
  );

  Shopify.addListener(
    this.countryEl,
    "change",
    Shopify.bind(this.countryHandler, this)
  );

  this.initCountry();
  this.initProvince();
};

Shopify.CountryProvinceSelector.prototype = {
  initCountry: function () {
    var value = this.countryEl.getAttribute("data-default");
    Shopify.setSelectorByValue(this.countryEl, value);
    this.countryHandler();
  },

  initProvince: function () {
    var value = this.provinceEl.getAttribute("data-default");
    if (value && this.provinceEl.options.length > 0) {
      Shopify.setSelectorByValue(this.provinceEl, value);
    }
  },

  countryHandler: function (e) {
    var opt = this.countryEl.options[this.countryEl.selectedIndex];
    var raw = opt.getAttribute("data-provinces");
    var provinces = JSON.parse(raw);

    this.clearOptions(this.provinceEl);
    if (provinces && provinces.length == 0) {
      this.provinceContainer.style.display = "none";
    } else {
      for (var i = 0; i < provinces.length; i++) {
        var opt = document.createElement("option");
        opt.value = provinces[i][0];
        opt.innerHTML = provinces[i][1];
        this.provinceEl.appendChild(opt);
      }

      this.provinceContainer.style.display = "";
    }
  },

  clearOptions: function (selector) {
    while (selector.firstChild) {
      selector.removeChild(selector.firstChild);
    }
  },

  setOptions: function (selector, values) {
    for (var i = 0, count = values.length; i < values.length; i++) {
      var opt = document.createElement("option");
      opt.value = values[i];
      opt.innerHTML = values[i];
      selector.appendChild(opt);
    }
  },
};

class MenuDrawer extends HTMLElement {
  constructor() {
    super();

    this.mainDetailsToggle = this.querySelector("details");
    const summaryElements = this.querySelectorAll("summary");
    this.addAccessibilityAttributes(summaryElements);

    if (navigator.platform === "iPhone")
      document.documentElement.style.setProperty(
        "--viewport-height",
        `${window.innerHeight}px`
      );

    this.addEventListener("keyup", this.onKeyUp.bind(this));
    this.addEventListener("focusout", this.onFocusOut.bind(this));
    this.bindEvents();
  }

  bindEvents() {
    this.querySelectorAll("summary").forEach((summary) =>
      summary.addEventListener("click", this.onSummaryClick.bind(this))
    );
    this.querySelectorAll("button").forEach((button) =>
      button.addEventListener("click", this.onCloseButtonClick.bind(this))
    );
  }

  addAccessibilityAttributes(summaryElements) {
    summaryElements.forEach((element) => {
      element.setAttribute("role", "button");
      element.setAttribute("aria-expanded", false);
      element.setAttribute("aria-controls", element.nextElementSibling.id);
    });
  }

  onKeyUp(e) {
    if (e.code.toUpperCase() !== "ESCAPE") return;

    const openDetailsElement = e.target.closest("details[open]");
    if (!openDetailsElement) return;

    openDetailsElement === this.mainDetailsToggle
      ? this.closeMenuDrawer(this.mainDetailsToggle.querySelector("summary"))
      : this.closeSubmenu(openDetailsElement);
  }

  onSummaryClick(e) {
    const summaryElement = e.currentTarget;
    const detailsElement = summaryElement.parentNode;
    const isOpen = detailsElement.hasAttribute("open");

    if (detailsElement === this.mainDetailsToggle) {
      if (isOpen) e.preventDefault();
      isOpen
        ? this.closeMenuDrawer(summaryElement)
        : this.openMenuDrawer(summaryElement);
    } else {
      trapFocus(
        summaryElement.nextElementSibling,
        detailsElement.querySelector("button")
      );

      setTimeout(() => {
        detailsElement.classList.add("menu-opening");
      });
    }
  }

  openMenuDrawer(summaryElement) {
    setTimeout(() => {
      this.mainDetailsToggle.classList.add("menu-opening");
    });
    summaryElement.setAttribute("aria-expanded", true);
    trapFocus(this.mainDetailsToggle, summaryElement);
    document.body.classList.add(`overflow-hidden-${this.dataset.breakpoint}`);
  }

  closeMenuDrawer(e, elementToFocus = false) {
    if (e !== undefined) {
      this.mainDetailsToggle.classList.remove("menu-opening");
      this.mainDetailsToggle.querySelectorAll("details").forEach((details) => {
        details.removeAttribute("open");
        details.classList.remove("menu-opening");
      });
      this.mainDetailsToggle
        .querySelector("summary")
        .setAttribute("aria-expanded", false);
      document.body.classList.remove(
        `overflow-hidden-${this.dataset.breakpoint}`
      );
      removeTrapFocus(elementToFocus);
      this.closeAnimation(this.mainDetailsToggle);
    }
  }

  onFocusOut(e) {
    setTimeout(() => {
      if (
        this.mainDetailsToggle.hasAttribute("open") &&
        !this.mainDetailsToggle.contains(document.activeElement)
      )
        this.closeMenuDrawer();
    });
  }

  onCloseButtonClick(e) {
    const detailsElement = e.currentTarget.closest("details");
    this.closeSubmenu(detailsElement);
  }

  closeSubmenu(detailsElement) {
    detailsElement.classList.remove("menu-opening");
    removeTrapFocus();
    this.closeAnimation(detailsElement);
  }

  closeAnimation(detailsElement) {
    let animationStart;

    const handleAnimation = (time) => {
      if (animationStart === undefined) {
        animationStart = time;
      }

      const elapsedTime = time - animationStart;

      if (elapsedTime < 400) {
        window.requestAnimationFrame(handleAnimation);
      } else {
        detailsElement.removeAttribute("open");
        if (detailsElement.closest("details[open]")) {
          trapFocus(
            detailsElement.closest("details[open]"),
            detailsElement.querySelector("summary")
          );
        }
      }
    };

    window.requestAnimationFrame(handleAnimation);
  }
}
customElements.define("menu-drawer", MenuDrawer);

class HeaderDrawer extends MenuDrawer {
  constructor() {
    super();
  }

  openMenuDrawer(summaryElement) {
    this.header =
      this.header || document.getElementById("shopify-section-header");
    this.borderOffset =
      this.borderOffset ||
      this.closest(".header-wrapper").classList.contains(
        "header-wrapper--border-bottom"
      )
        ? 1
        : 0;
    document.documentElement.style.setProperty(
      "--header-bottom-position",
      `${parseInt(
        this.header.getBoundingClientRect().bottom - this.borderOffset
      )}px`
    );

    setTimeout(() => {
      this.mainDetailsToggle.classList.add("menu-opening");
    });

    summaryElement.setAttribute("aria-expanded", true);
    trapFocus(this.mainDetailsToggle, summaryElement);
    document.body.classList.add(`overflow-hidden-${this.dataset.breakpoint}`);
  }
}
customElements.define("header-sidebar", HeaderDrawer);

class ModalDialog extends HTMLElement {
  constructor() {
    super();
    this.querySelector('[id^="ModalClose-"]').addEventListener(
      "click",
      this.hide.bind(this)
    );
    this.addEventListener("keyup", (e) => {
      if (e.code.toUpperCase() === "ESCAPE") this.hide();
    });
    if (this.classList.contains("media-modal")) {
      this.addEventListener("pointerup", (e) => {
        if (
          e.pointerType === "mouse" &&
          !e.target.closest("deferred-media, product-model")
        )
          this.hide();
      });
    } else {
      this.addEventListener("click", (e) => {
        if (e.target.nodeName === "MODAL-DIALOG") this.hide();
      });
    }
  }

  show(opener) {
    this.openedBy = opener;
    const popup = this.querySelector(".template-popup");
    document.body.classList.add("overflow-hidden");
    this.setAttribute("open", "");
    if (popup) popup.loadContent();
    trapFocus(this, this.querySelector('[role="dialog"]'));
    window.pauseAllMedia();
  }

  hide() {
    document.body.classList.remove("overflow-hidden");
    this.removeAttribute("open");
    removeTrapFocus(this.openedBy);
    window.pauseAllMedia();
  }
}
customElements.define("modal-dialog", ModalDialog);

class ModalOpener extends HTMLElement {
  constructor() {
    super();

    const button = this.querySelector("button");

    if (!button) return;
    button.addEventListener("click", () => {
      const modal = document.querySelector(this.getAttribute("data-modal"));
      if (modal) modal.show(button);
    });
  }
}
customElements.define("modal-opener", ModalOpener);

class DeferredMedia extends HTMLElement {
  constructor() {
    super();
    const poster = this.querySelector('[id^="Deferred-Poster-"]');
    if (!poster) return;
    poster.addEventListener("click", this.loadContent.bind(this));
  }

  loadContent() {
    window.pauseAllMedia();
    if (!this.getAttribute("loaded")) {
      const content = document.createElement("div");
      content.appendChild(
        this.querySelector("template").content.firstElementChild.cloneNode(true)
      );

      this.setAttribute("loaded", true);
      this.appendChild(
        content.querySelector("video, model-viewer, iframe")
      ).focus();
    }
  }
}
customElements.define("deferred-media", DeferredMedia);

class SliderComponent extends HTMLElement {
  constructor() {
    super();
    this.slider = this.querySelector("ul");
    this.sliderItems = this.querySelectorAll("li");
    this.pageCount = this.querySelector(".slider-counter--current");
    this.pageTotal = this.querySelector(".slider-counter--total");
    this.prevButton = this.querySelector('button[name="previous"]');
    this.nextButton = this.querySelector('button[name="next"]');

    if (!this.slider || !this.nextButton) return;

    const resizeObserver = new ResizeObserver((entries) => this.initPages());
    resizeObserver.observe(this.slider);

    this.slider.addEventListener("scroll", this.update.bind(this));
    this.prevButton.addEventListener("click", this.onButtonClick.bind(this));
    this.nextButton.addEventListener("click", this.onButtonClick.bind(this));
  }

  connectedCallback() {
    console.log("slider active at", this);
  }

  initPages() {
    const sliderItemsToShow = Array.from(this.sliderItems).filter(
      (element) => element.clientWidth > 0
    );
    this.sliderLastItem = sliderItemsToShow[sliderItemsToShow.length - 1];
    if (sliderItemsToShow.length === 0) return;
    this.slidesPerPage = Math.floor(
      this.slider.clientWidth / sliderItemsToShow[0].clientWidth
    );
    this.totalPages = sliderItemsToShow.length - this.slidesPerPage + 1;
    this.update();
  }

  update() {
    if (!this.pageCount || !this.pageTotal) return;
    this.currentPage =
      Math.round(this.slider.scrollLeft / this.sliderLastItem.clientWidth) + 1;

    if (this.currentPage === 1) {
      this.prevButton.setAttribute("disabled", "disabled");
    } else {
      this.prevButton.removeAttribute("disabled");
    }

    if (this.currentPage === this.totalPages) {
      this.nextButton.setAttribute("disabled", "disabled");
    } else {
      this.nextButton.removeAttribute("disabled");
    }
    // Add leading 0.
    this.pageCount.textContent = ("0" + this.currentPage).slice(-2);
    this.pageTotal.textContent = ("0" + this.totalPages).slice(-2);
  }

  onButtonClick(e) {
    e.preventDefault();
    const slideScrollPosition =
      e.currentTarget.name === "next"
        ? this.slider.scrollLeft + this.sliderLastItem.clientWidth
        : this.slider.scrollLeft - this.sliderLastItem.clientWidth;
    this.slider.scrollTo({
      left: slideScrollPosition,
    });
  }
}
customElements.define("slider-component", SliderComponent);

// VariantSelects and VariantRadios rely on a bizarre, nonperformant fetch solution, avoid use in favor of mage included code -ae 11.11.21
class VariantSelects extends HTMLElement {
  constructor() {
    super();
    this.addEventListener("change", this.onVariantChange);
  }

  onVariantChange() {
    console.log("hi this is currentVariant", this.currentVariant);
    this.updateOptions();
    this.updateMasterId();
    this.toggleAddButton(true, "", false);
    this.updatePickupAvailability();
    this.removeErrorMessage();

    if (!this.currentVariant) {
      this.toggleAddButton(true, "", true);
      this.setUnavailable();
    } else {
      this.updateMedia();
      this.updateMastheadMedia();
      this.updateURL();
      this.updateVariantInput();
      this.renderProductInfo();
    }
  }

  updateOptions() {
    this.options = Array.from(
      this.querySelectorAll("select"),
      (select) => select.value
    );
  }

  updateMasterId() {
    this.currentVariant = this.getVariantData().find((variant) => {
      return !variant.options
        .map((option, index) => {
          return this.options[index] === option;
        })
        .includes(false);
    });
  }

  updateMedia() {
    if (!this.currentVariant) return;
    if (!this.currentVariant.featured_media) return;
    const newMedia = document.querySelector(
      `[data-media-id="${this.dataset.section}-${this.currentVariant.featured_media.id}"]`
    );

    if (!newMedia) return;
    const modalContent = document.querySelector(
      `#ProductModal-${this.dataset.section} .product-media-modal__content`
    );
    const newMediaModal = modalContent.querySelector(
      `[data-media-id="${this.currentVariant.featured_media.id}"]`
    );
    const parent = newMedia.parentElement;
    if (parent.firstChild == newMedia) return;
    modalContent.prepend(newMediaModal);
    parent.prepend(newMedia);
    this.stickyHeader =
      this.stickyHeader || document.querySelector("sticky-header");
    if (this.stickyHeader) {
      this.stickyHeader.dispatchEvent(new Event("preventHeaderReveal"));
    }
    // window.setTimeout(() => { parent.querySelector('li.product__media-item').scrollIntoView({ behavior: 'smooth' }); });
  }

  updateMastheadMedia() {
    if (!this.currentVariant) return;
    const mastheadTarget = document.querySelector(".pdpMasthead");
    const mastheadTargetImg = mastheadTarget?.querySelector("img");
    if (!mastheadTarget) {
      console.log("Masthead Section not loaded");
      return;
    }

    const mastheadData = this.getVariantMetafieldData();
    const currentVariantMastheadData = mastheadData.find(
      (variant) => variant.id === this.currentVariant.id
    );

    if (currentVariantMastheadData.masthead_available) {
      mastheadTarget.srcset = currentVariantMastheadData.masthead_src;
      mastheadTargetImg.src = currentVariantMastheadData.masthead_src;
    }
  }

  updateURL() {
    console.log("does this fire?");
    if (!this.currentVariant || this.dataset.updateUrl === "false") return;
    window.history.replaceState(
      {},
      "",
      `${this.dataset.url}?variant=${this.currentVariant.id}`
    );
  }

  updateVariantInput() {
    const productForms = document.querySelectorAll(
      `#product-form-${this.dataset.section}, #product-form-installment`
    );
    productForms.forEach((productForm) => {
      const input = productForm.querySelector('input[name="id"]');
      input.value = this.currentVariant.id;
      input.dispatchEvent(new Event("change", { bubbles: true }));
    });
  }

  updatePickupAvailability() {
    const pickUpAvailability = document.querySelector("pickup-availability");
    if (!pickUpAvailability) return;

    if (this.currentVariant && this.currentVariant.available) {
      pickUpAvailability.fetchAvailability(this.currentVariant.id);
    } else {
      pickUpAvailability.removeAttribute("available");
      pickUpAvailability.innerHTML = "";
    }
  }

  removeErrorMessage() {
    const section = this.closest("section");
    if (!section) return;

    const productForm = section.querySelector("product-form");
    if (productForm) productForm.handleErrorMessage();
  }

  renderProductInfo() {
    console.log("renderProductInfo fetch running");
    fetch(
      `${this.dataset.url}?variant=${this.currentVariant.id}&section_id=${this.dataset.section}`
    )
      .then((response) => response.text())
      .then((responseText) => {
        const id = `price-${this.dataset.section}`;
        const html = new DOMParser().parseFromString(responseText, "text/html");
        const destination = document.getElementById(id);
        const source = html.getElementById(id);

        if (source && destination) destination.innerHTML = source.innerHTML;

        const price = document.getElementById(`price-${this.dataset.section}`);
        console.log(
          `${this.dataset.url}?variant=${this.currentVariant.id}&section_id=${this.dataset.section}`
        );
        if (price) price.classList.remove("visibility-hidden");

        this.toggleAddButton(
          !this.currentVariant.available,
          window.variantStrings.soldOut
        );
      });
  }

  toggleAddButton(disable = true, text, modifyClass = true) {
    const productForm = document.getElementById(
      `product-form-${this.dataset.section}`
    );
    if (!productForm) return;
    const addButton = productForm.querySelector('[name="add"]');
    const addButtonText = productForm.querySelector("[data-atc-status]");

    if (!addButton) return;

    if (disable) {
      addButton.setAttribute("disabled", "disabled");
      if (text) addButtonText.textContent = text;
    } else {
      addButton.removeAttribute("disabled");
      addButtonText.textContent = window.variantStrings.addToCart;
    }

    if (!modifyClass) return;
  }

  setUnavailable() {
    const button = document.getElementById(
      `product-form-${this.dataset.section}`
    );
    const addButton = button.querySelector('[name="add"]');
    const addButtonText = button.querySelector('[name="add"] > span');
    const price = document.getElementById(`price-${this.dataset.section}`);
    if (!addButton) return;
    addButtonText.textContent = window.variantStrings.unavailable;
    if (price) price.classList.add("visibility-hidden");
  }

  getVariantData() {
    this.variantData =
      this.variantData ||
      JSON.parse(this.querySelector("[data-variant]").textContent);
    return this.variantData;
  }

  getVariantMetafieldData() {
    const variantMetafieldDataTarget = this.querySelector(
      "[data-variant-metafield]"
    );
    if (!variantMetafieldDataTarget) {
      console.log("Variant Metafield Data not found");
      return;
    }
    this.variantMetafieldData =
      this.variantMetafieldData ||
      JSON.parse(variantMetafieldDataTarget.textContent);
    return this.variantMetafieldData;
  }
}
customElements.define("variant-selects", VariantSelects);

class VariantRadios extends VariantSelects {
  constructor() {
    super();
  }

  updateOptions() {
    const fieldsets = Array.from(this.querySelectorAll("fieldset"));
    this.options = fieldsets.map((fieldset) => {
      return Array.from(fieldset.querySelectorAll("input")).find(
        (radio) => radio.checked
      ).value;
    });
  }
}
customElements.define("variant-radios", VariantRadios);

class ProductDescription extends HTMLElement {
  constructor() {
    super();
    this.descriptionText = this.querySelector(".js-descriptionText");
    this.showMore = this.querySelector(".js-productDescriptionShowMore");
    if (this.showMore != null) {
      this.showMore.addEventListener("click", this.showMoreClick.bind(this));
    }
  }

  showMoreClick(e) {
    e.preventDefault();
    this.descriptionText.classList.toggle("is-truncated");

    if (this.descriptionText.classList.contains("is-truncated")) {
      this.showMore.innerHTML = "Read More";
    } else {
      this.showMore.innerHTML = "Read Less";
    }
  }
}
customElements.define("product-description", ProductDescription);

class QuantityInput extends HTMLElement {
  constructor() {
    super();
    this.input = this.querySelector("input");
    this.changeEvent = new Event("change", { bubbles: true });

    this.querySelectorAll("button").forEach((button) =>
      button.addEventListener("click", this.onButtonClick.bind(this))
    );
  }

  onButtonClick(e) {
    e.preventDefault();
    const previousValue = this.input.value;

    e.target.name === "plus" ? this.input.stepUp() : this.input.stepDown();
    if (previousValue !== this.input.value)
      this.input.dispatchEvent(this.changeEvent);
  }
}
customElements.define("quantity-input", QuantityInput);

// Product Card
class ProductCard extends HTMLElement {
  constructor() {
    super();

    this.colorSelectors = this.querySelectorAll(".js-color-update");
    this.productLinks = this.querySelectorAll(".js-product-link");
    this.variantImages = this.querySelectorAll(".js-variant-image");
    this.price = this.querySelectorAll("[data-selected-card-price]");
    this.compareAtPrice = this.querySelectorAll("[data-selected-card-compare]");
    this.variantInventory = this.querySelectorAll("[data-variant-inventory-quantity]");

    this.tagContainer = this.querySelector("[data-product-card-tags]")
    this.soldOutTag = this.querySelectorAll(".js-tag--sold-out");

    this.soldOutTagHtml = `<span class="tag tag--sold-out js-tag--sold-out">Sold Out</span>`;

    if (this.querySelector(".js-product-card-add")) {
      this.atcButton = this.querySelector(".js-product-card-add");
    } else {
      this.atcButton = null;
    }

    this.currentSelected = null;
    this.currentSelectedOption = null;
    this.currentId = null;
    this.currentLink = null;
  }

  connectedCallback() {
    // setting these to null initially allows for card variant to be unset initially.
    // let this.currentSelected = null;
    // let this.currentId = null;

    // set initial variables
    this.currentSelected = this.colorSelectors[0];
    // Bail if no color swatches
    if (this.currentSelected === undefined) {
      return;
    }
    // set initial selected option
    this.currentSelectedOption = this.currentSelected.querySelector(
      ".js-productCard-option"
    );
    // set initial variant id
    this.currentId = this.currentSelectedOption.getAttribute("data-variant-id");
    // set initial price var
    this.currentPrice =
      this.currentSelectedOption.getAttribute("data-variant-price");
    // set initial compare at price var
    this.currentCompareAtPrice = this.currentSelectedOption.getAttribute(
      "data-variant-compare"
    );
    // set initial variant inventory quantity
    this.currentVariantInventory = this.currentSelectedOption.getAttribute(
      "data-variant-inventory-quantity"
    );
    // set initial link
    this.currentLink =
      this.currentSelectedOption.getAttribute("data-variant-url");

    this.productLinks.forEach((link) => {
      link.setAttribute("href", this.currentLink);
    });
    // set initial image
    this.variantImages.forEach((image) => {
      if (image.getAttribute("data-variant-id") !== this.currentId) {
        if (image.classList.contains("is-visible")) {
          image.classList.remove("is-visible");
        }
      } else {
        image.classList.add("is-visible");
      }
    });
    // set initial price
    this.price.forEach((priceEl) => {
      priceEl.innerHTML = this.currentPrice;
    });
    // set initial compare at price
    this.compareAtPrice.forEach((priceEl) => {
      priceEl.innerHTML = this.currentCompareAtPrice;
    });

    // Set initial tags
    this.setTags();

    this.colorSelectors.forEach((item, i) => {
      // strip limited edition
      if (item.hasAttribute("data-swatch")) {
        // console.log(i, item.getAttribute('data-swatch'));
        if (item.getAttribute("data-swatch").includes("limited")) {
          const swatchVal = item.getAttribute("data-swatch");
          let strVal = swatchVal.toString();
          strVal = strVal.replace("limited-edition-", "");
          item.dataset.color = strVal;
        }
      } else if (item.hasAttribute("data-material")) {
        if (item.getAttribute("data-material").includes("limited")) {
          const swatchVal = item.getAttribute("data-material");
          let strVal = swatchVal.toString();
          strVal = strVal.replace("limited-edition-", "");
          item.dataset.color = strVal;
        }
      }

      // update data on click
      item.addEventListener("click", () => {
        // If clicked item isn't currently selected, find what is and removed checked.
        if (item !== this.currentSelected) {
          if (this.currentSelected) {
            this.currentSelected
              .querySelector("input")
              .classList.remove("is-active");
          }
          // Set active item
          item.querySelector("input").classList.add("is-active");
          this.currentSelected = item;
          this.currentSelectedOption = this.currentSelected.querySelector(
            ".js-productCard-option"
          );

          this.currentId =
            this.currentSelectedOption.getAttribute("data-variant-id");
          // update price var
          this.currentPrice =
            this.currentSelectedOption.getAttribute("data-variant-price");
          // update compare at price var
          this.currentCompareAtPrice = this.currentSelectedOption.getAttribute(
            "data-variant-compare"
          );
          // update inventory quantity
          this.currentVariantInventory = this.currentSelectedOption.getAttribute(
            "data-variant-inventory-quantity"
          );
          // update productCard link
          this.currentLink =
            this.currentSelectedOption.getAttribute("data-variant-url");
          this.productLinks.forEach((link) => {
            link.setAttribute("href", this.currentLink);
          });
          // update productCard price if enabled
          this.price.forEach((priceEl) => {
            priceEl.innerHTML = this.currentPrice;
          });
          // update productCard compare at price if enabled
          this.compareAtPrice.forEach((priceEl) => {
            priceEl.innerHTML = this.currentCompareAtPrice;
          });

          // Change Image
          this.variantImages.forEach((image) => {
            if (image.getAttribute("data-variant-id") !== this.currentId) {
              if (image.classList.contains("is-visible")) {
                image.classList.remove("is-visible");
              }
            } else {
              image.classList.add("is-visible");
            }
          });

          // Update tags
          // if (this.tagContainer != null) {
          //   if (this.currentVariantInventory == 0) {
          //     this.soldOutTag.forEach((tag) => {
          //       tag.classList.remove("is-hidden");
          //       tag.classList.add("is-visible");
          //     });
          //   } else {
          //     this.soldOutTag.forEach((tag) => {
          //       tag.classList.remove("is-visible");
          //       tag.classList.add("is-hidden");
          //     });
          //   }
          // }

          this.setTags();

          console.log(this.currentLink);
        }
      });
    });

    // Update Add to Cart Button if available
    if (this.atcButton) {
      this.atcButton.addEventListener("click", (e) =>
        this.atcClick(e, this.currentId)
      );
    }
  }

  atcClick(e, currentId) {
    e.preventDefault();

    if (currentId) {
      console.log(currentId);
      addItemById(currentId, 1);
    } else {
      const err = `currentId returns ${currentId}`;
      throw new Error(err);
    }
  }

  setTags() {
    if (this.tagContainer === null) {
      console.warn(this + "tagContainer is null");
      return;
    }

    console.log(
      "does tagContainer contain soldOut?",
      this.tagContainer.contains(this.soldOutTag[0])
    );
    // if tagContainer does not contain soldOutTag, and currentVariantInventory is 0, insert soldOutTag
    if (
      !this.tagContainer.contains(this.querySelector('.js-tag--sold-out')) &&
      this.currentVariantInventory == 0
    ) {
      this.tagContainer.insertAdjacentHTML(
        "beforeend",
        this.soldOutTagHtml
      );
      console.log("setTags fired");
    }
    // if tagContainer contains soldOutTag, and currentVariantInventory is 0, set soldOutTag to visible
    // if (this.currentVariantInventory == 0) {
    //   this.querySelectorAll('.js-tag--sold-out').forEach((tag) => {
    //     console.log("setTags fired");
    //   });
    // }
    if (this.currentVariantInventory > 0) {
      this.querySelectorAll('.js-tag--sold-out').forEach((tag) => {
        tag.remove();
        console.log("setTags fired");
      });
    }
  }
}
customElements.define("product-card", ProductCard);

// Product Card Small
class ProductCardSmall extends ProductCard {
  constructor() {
    super();
  }
}
customElements.define("product-card-small", ProductCardSmall);

class CollapsibleTab extends HTMLElement {
  constructor() {
    super();
    // Store the <details> element
    this.el = this.querySelector("details");
    // Store the <summary> element
    this.summary = this.querySelector("summary");
    // Store the <div class="content"> element
    this.content = this.querySelector(".content");

    // Store the animation object (so we can cancel it if needed)
    this.animation = null;
    // Store if the element is closing
    this.isClosing = false;
    // Store if the element is expanding
    this.isExpanding = false;
    // Detect user clicks on the summary element
    this.summary.addEventListener("click", (e) => this.onClick(e));
  }

  onClick(e) {
    // Stop default behaviour from the browser
    e.preventDefault();
    // Add an overflow on the <details> to avoid content overflowing
    this.el.style.overflow = "hidden";
    // Check if the element is being closed or is already closed
    if (this.isClosing || !this.el.open) {
      this.open();
      // Check if the element is being opened or is already open
    } else if (this.isExpanding || this.el.open) {
      this.shrink();
    }
  }

  shrink() {
    // Set the element as "being closed"
    this.isClosing = true;

    // Store the current height of the element
    const startHeight = `${this.el.offsetHeight}px`;
    // Calculate the height of the summary
    const endHeight = `${this.summary.offsetHeight}px`;

    // If there is already an animation running
    if (this.animation) {
      // Cancel the current animation
      this.animation.cancel();
    }

    // Start a WAAPI animation
    this.animation = this.el.animate(
      {
        // Set the keyframes from the startHeight to endHeight
        height: [startHeight, endHeight],
      },
      {
        duration: 250,
        easing: "ease",
      }
    );

    // When the animation is complete, call onAnimationFinish()
    this.animation.onfinish = () => {
      this.onAnimationFinish(false);
      this.classList.remove("opened");
    };
    // If the animation is cancelled, isClosing variable is set to false
    this.animation.oncancel = () => (this.isClosing = false);
  }

  open() {
    // Apply a fixed height on the element
    this.el.style.height = `${this.el.offsetHeight}px`;
    // Force the [open] attribute on the details element
    this.el.open = true;
    // Wait for the next frame to call the expand function
    window.requestAnimationFrame(() => this.expand());
  }

  expand() {
    // Set the element as "being expanding"
    this.isExpanding = true;
    // Get the current fixed height of the element
    const startHeight = `${this.el.offsetHeight}px`;
    // Calculate the open height of the element (summary height + content height)
    const endHeight = `${
      this.summary.offsetHeight + this.content.offsetHeight
    }px`;

    // If there is already an animation running
    if (this.animation) {
      // Cancel the current animation
      this.animation.cancel();
    }

    // Start a WAAPI animation
    this.animation = this.el.animate(
      {
        // Set the keyframes from the startHeight to endHeight
        height: [startHeight, endHeight],
      },
      {
        duration: 250,
        easing: "ease",
      }
    );
    // When the animation is complete, call onAnimationFinish()
    this.animation.onfinish = () => {
      this.onAnimationFinish(true);
      this.classList.add("opened");
    };
    // If the animation is cancelled, isExpanding variable is set to false
    this.animation.oncancel = () => (this.isExpanding = false);
  }

  onAnimationFinish(open) {
    // Set the open attribute based on the parameter
    this.el.open = open;
    // Clear the stored animation
    this.animation = null;
    // Reset isClosing & isExpanding
    this.isClosing = false;
    this.isExpanding = false;
    // Remove the overflow hidden and the fixed height
    this.el.style.height = this.el.style.overflow = "";
  }
}
customElements.define("collapsible-tab", CollapsibleTab);

// Collapsible Tab 2.0 - TODO: Refactor to use CSS Animations
// See - https://linkedlist.ch/animate_details_element_60/
class CollaspibleTabNew extends HTMLElement {
  constructor() {
    super();
  }
}
customElements.define("collapsible-tab-new", CollaspibleTabNew);

// Upsell Products
class UpsellProducts extends HTMLElement {
  constructor() {
    super();
    this.upsellSliderMount = document.querySelector("[data-slider]");
  }

  connectedCallback() {
    if (window.KeenSlider) {
      const prevButtons = this.querySelectorAll(".slider-button--prev");
      const nextButtons = this.querySelectorAll(".slider-button--next");
      const upsellActiveSlide = this.querySelector(".js-count--current");
      const upsellTotalSlides = this.querySelector(".js-count--total");
      function upsellPlugin() {
        return (slider) => {
          slider.on("created", () => {
            prevButtons.forEach((el, i) => {
              el.addEventListener("click", function () {
                slider.prev();
                // prev doesn't seem to work if all slides are visible
                if (slider.track.details.rel > slider.track.details.minIdx) {
                  slider.track.details.rel = slider.track.details.rel - 1;
                }
                console.log("prev fired", slider);
              });
            });
            nextButtons.forEach((el, i) => {
              el.addEventListener("click", function () {
                slider.next();
                // next doesn't work if all slides are visible in viewport
                if (slider.track.details.rel < slider.track.details.maxIdx) {
                  slider.track.details.rel = slider.track.details.rel + 1;
                }
                console.log("next fired", slider);
              });
            });
            const totalNumberStr = slider.slides.length.toString();
            const leadingZeroTotalNumber = totalNumberStr.padStart(2, "0");
            upsellTotalSlides.innerHTML = leadingZeroTotalNumber;
          });
          slider.on("slideChanged", () => {
            const activeNumberStr = (slider.track.details.rel + 1).toString();
            const leadingZeroActiveNumber = activeNumberStr.padStart(2, "0");
            upsellActiveSlide.innerHTML = leadingZeroActiveNumber;
            console.log(`slide changed, updated to ${leadingZeroActiveNumber}`);
          });
        };
      }

      this.thumbnailSlider = new KeenSlider(
        this.upsellSliderMount,
        {
          loop: true,
          mode: "free-snap",
          slides: {
            perView: 1,
            spacing: 14,
          },
        },
        [upsellPlugin()]
      );
    }
  }
}
customElements.define("upsell-products", UpsellProducts);

// Product Specs
class ProductSpecs extends HTMLElement {
  constructor() {
    super();
    // Store Containing Element
    this.group = this.querySelector(".specification-items");
    // Store all <details> elements
    this.details = this.group.getElementsByClassName("product-specification");
    // Store all <summary> elements
    this.summaries = this.group.getElementsByClassName(
      "product-specification__summary"
    );
    // Store all <div class="content"> elements
    this.contents = this.group.getElementsByClassName(
      "product-specification__content"
    );

    // Get tab settings from data-attrs if they exist
    this.speedSetting = this.getAttribute("data-speed");
    this.visibleSetting = this.getAttribute("data-one-visible");
    this.closeSelf = this.getAttribute("data-close-self");

    // Set default settings if necessary
    if (!this.speedSetting) {
      this.speedSetting = 500;
    }
    if (!this.visibleSetting) {
      this.visibleSetting = true;
    }
    if (!this.closeSelf) {
      true;
    }

    // Assign tab settings
    this.settings = Object.assign({
      speed: this.speedSetting,
      oneVisible: this.visibleSetting,
      closeSelf: this.closeSelf,
    });

    // Setup inital positions
    for (let i = 0; i < this.details.length; i++) {
      const detail = this.details[i];
      const toggle = this.summaries[i];
      const content = this.contents[i];

      // Set transition-duration to match JS setting
      detail.style.transitionDuration = `${this.settings.speed}ms`;

      // Set initial height to transition from
      if (!detail.hasAttribute("open")) {
        detail.style.height = `${toggle.clientHeight}px`;
      } else {
        detail.style.height = `${toggle.clientHeight + content.clientHeight}px`;
      }
    }

    // Setup click handler
    this.group.addEventListener("click", (e) => {
      if (e.target.classList.contains("product-specification__summary")) {
        e.preventDefault();

        let num = 0;
        for (let i = 0; i < this.summaries.length; i++) {
          if (this.summaries[i] === e.target) {
            num = i;
            break;
          }
        }

        if (!e.target.parentNode.hasAttribute("open")) {
          this.open(num);
        } else if (this.settings.closeSelf) {
          console.log("trying to close self");
          this.close(num);
        }
      }
    });
  }

  connectedCallback() {
    this.open(0);
  }

  open(i) {
    const detail = this.details[i];
    const toggle = this.summaries[i];
    const content = this.contents[i];

    const activeMediaContainer = detail.querySelector(
      ".js-ps-active-media-container"
    );
    let activeMedia = detail.querySelector(".js-ps-active-media");

    // If applicable, hide all the other details first
    if (this.settings.oneVisible) {
      for (let a = 0; a < this.summaries.length; a++) {
        if (i !== a) this.close(a);
      }
    }

    // Update class
    detail.classList.remove("is-closing");

    // Get height of toggle
    const toggleHeight = toggle.clientHeight;

    // Momentarily show the contents just to get the height
    detail.setAttribute("open", true);
    const contentHeight = content.clientHeight;
    detail.removeAttribute("open");

    // Set the correct height and let CSS transition it
    detail.style.height = `${toggleHeight + contentHeight}px`;

    // Finally set the open attr
    detail.setAttribute("open", true);

    if (activeMediaContainer) {
      // For Media Update
      const template = detail.querySelector(".specification-media-template");
      const templateClone = template.content.firstElementChild.cloneNode(true);
      // For Video Setup
      const videoUrl = template.getAttribute("data-videourl");

      if (videoUrl && window.getVideoId) {
        var videoId = getVideoId(videoUrl).id;
        var videoService = getVideoId(videoUrl).service;
      }

      if (videoId) {
        template.setAttribute("data-videoid", videoId);
      }

      // Change currently displayed media
      activeMediaContainer.replaceChild(templateClone, activeMedia);
      const newActiveMedia = activeMediaContainer.children[0];
      // Re-add activeMedia class
      newActiveMedia.classList.add("js-ps-active-media");
      // Re-assign activeMedia to newly added media
      activeMedia = newActiveMedia;

      // Sort video URL if video
      if (activeMedia.classList.contains("js-video-iframe")) {
        if (videoId && videoService === "youtube") {
          activeMedia.setAttribute(
            "src",
            `https://www.youtube.com/embed/${videoId}?enablejsapi=1`
          );
        }
      }
    }
  }

  close(i) {
    const detail = this.details[i];
    const toggle = this.summaries[i];

    // Update class
    detail.classList.add("is-closing");

    // Get height of toggle
    const toggleHeight = toggle.clientHeight;

    // Set the height so only the toggle is visible
    detail.style.height = `${toggleHeight}px`;

    setTimeout(() => {
      // Check if still closing
      if (detail.classList.contains("is-closing")) {
        detail.removeAttribute("open");
      }
      detail.classList.remove("is-closing");
    }, this.settings.speed);
  }
}
customElements.define("product-specs", ProductSpecs);

// Offscreen Slider
class OffscreenSlider extends HTMLElement {
  constructor() {
    super();
    this.snapToNearestSlide = this.snapToNearestSlide.bind(this);
  }

  connectedCallback() {
    const track = this.querySelector(".offscreen-slider__track");
    const trackWrapper = this.querySelector(".track__wrapper");

    // Setup slides
    const firstSlide = track.querySelector(".offscreen-slider__card");
    const slideWidth = firstSlide ? firstSlide.offsetWidth : 0;
    const gap =
      parseFloat(
        getComputedStyle(
          track.querySelector(".track__wrapper")
        ).getPropertyValue("gap")
      ) || 0;
    const slideWidthWithGap = slideWidth + gap;
    const centerOffset =
      slideWidth / 2 -
      track.offsetWidth / 2 +
      (track.offsetWidth - trackWrapper.offsetWidth) / 2;
    this.snapToNearestSlide = this.snapToNearestSlide.bind(
      this,
      slideWidthWithGap,
      centerOffset
    );

    // Event handling
    let isDown = false;
    let startX;
    let scrollLeft;

    track.addEventListener("mousedown", (e) => {
      isDown = true;
      track.classList.add("active");
      startX = e.pageX - track.getBoundingClientRect().left;
      scrollLeft = track.scrollLeft;
    });

    track.addEventListener("mouseleave", () => {
      isDown = false;
      track.classList.remove("active");
    });

    track.addEventListener("mouseup", () => {
      isDown = false;
      setTimeout(() => {
        this.snapToNearestSlide(track.scrollLeft);
        setTimeout(() => {
          track.classList.remove("active");
        }, 750);
      }, 200);
    });

    track.addEventListener("mousemove", (e) => {
      if (!isDown) return;
      e.preventDefault();
      const x = e.pageX - track.getBoundingClientRect().left;
      const walk = (x - startX) * 2;
      track.scrollLeft = scrollLeft - walk;
    });
  }

  snapToNearestSlide(slideWidthWithGap, centerOffset, currentScroll) {
    const index = Math.round(
      currentScroll / (slideWidthWithGap + centerOffset)
    );
    const targetScrollPosition = index * slideWidthWithGap + centerOffset;
    this.querySelector(".offscreen-slider__track").scrollTo({
      left: targetScrollPosition,
      behavior: "smooth",
    });

    console.log("snapped to slide", index);
  }
}
customElements.define("offscreen-slider", OffscreenSlider);

// Marquee
function createMarquee(marqueeItem, itemWidth, reps, speed) {
  return `
      ${new Array(2)
        .fill(0)
        .map((_, clone) => {
          return `
            <div
              data-marqy-content
              style=
                "animation-duration: ${
                  ((itemWidth ?? 0) * reps) / (100 * speed)
                }s;"
            >
            ${new Array(reps)
              .fill(0)
              .map((_, rep) => {
                const isFirstItem = clone === 0 && rep === 0;
                return `
                  <div
                    data-marqy-item
                    aria-hidden=${!isFirstItem}
                  >
                    ${marqueeItem.innerHTML}
                  </div>
                `;
              })
              .join("")}
            </div>
          `;
        })
        .join("")}
    `;
}
class Marqy extends HTMLElement {
  constructor() {
    super();
    // define refs
    this.containerWidth = this.offsetWidth;
    this.marqueeMount = this.querySelector(".js-marquee--mount");
    this.marqueeItem = this.querySelector(".js-marquee--item");
    // set state
    this.marqyState = {
      reps: 1,
      containerWidth: this.containerWidth,
      speed: 0.2,
    };
  }

  connectedCallback() {
    // define widths
    this.containerWidth = this.offsetWidth;
    this.itemWidth = this.marqueeItem.offsetWidth;
    // set number of reps
    if (this.containerWidth && this.itemWidth) {
      this.marqyState.reps = Math.ceil(this.containerWidth / this.itemWidth);
    } else {
      if (this.containerWidth) {
        console.log("no itemWidth");
      }
      if (this.itemWidth) {
        console.log("no containerWidth");
      }
    }
    // establish resize listener
    const resizeObserver = new ResizeObserver(([entry]) => {
      this.containerWidth = entry.contentRect.width;
      this.marqyState.containerWidth = entry.contentRect.width;
    });
    // observe container
    resizeObserver.observe(this);
    // observe items
    resizeObserver.observe(this.marqueeItem);

    // initial render
    this.marqueeMount.innerHTML = createMarquee(
      this.marqueeItem,
      this.itemWidth,
      this.marqyState.reps,
      this.marqyState.speed
    );
  }
}
customElements.define("marquee-section", Marqy);
